// extracted by mini-css-extract-plugin
export default {"modelMail":"styles_modelMail__REaoV","buttonSection":"styles_buttonSection__GjezC","button":"styles_button__Izut4","button1":"styles_button1__MMtuE"};